"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regexStreetAddress = void 0;
exports.parseAndValidateStreetAddress = parseAndValidateStreetAddress;
exports.parseStreetAddress = parseStreetAddress;
exports.isValidF2100StreetAddress = isValidF2100StreetAddress;
exports.regexStreetAddress = /^(.*?)(\s(\d*)\s?(\S?))?$/;
const minStreetAddressLength = 2;
const maxStreetAddressLength = 50;
const maxStreetAddressNumberLength = 4;
function parseAndValidateStreetAddress(streetAddressAsString) {
    if (!streetAddressAsString) {
        return {
            isF2100Valid: false,
            isValid: false,
        };
    }
    const parsedStreetAddress = parseStreetAddress(streetAddressAsString);
    return Object.assign(Object.assign({}, parsedStreetAddress), { isF2100Valid: isValidF2100StreetAddressFormat(streetAddressAsString, parsedStreetAddress), isValid: true });
}
function parseStreetAddress(streetAddressAsString) {
    if (!streetAddressAsString) {
        return {};
    }
    const matches = streetAddressAsString.match(exports.regexStreetAddress);
    if (matches && matches.length > 1) {
        return {
            letter: matches.length > 4 && matches[4] !== "" ? matches[4] : undefined,
            number: matches.length > 3 && matches[3] !== "" ? matches[3] : undefined,
            street: matches[1],
        };
    }
    return {};
}
function isValidF2100StreetAddress(streetAddressAsString) {
    if (!streetAddressAsString) {
        return false;
    }
    return isValidF2100StreetAddressFormat(streetAddressAsString, parseStreetAddress(streetAddressAsString));
}
function isValidF2100StreetAddressFormat(streetAddressAsString, parsedStreetAddress) {
    var _a;
    if (!parsedStreetAddress ||
        !streetAddressAsString ||
        !(streetAddressAsString.length >= minStreetAddressLength &&
            streetAddressAsString.length <= maxStreetAddressLength)) {
        return false;
    }
    if (parsedStreetAddress.number) {
        return (`${parsedStreetAddress.number}${(_a = parsedStreetAddress.letter) !== null && _a !== void 0 ? _a : ""}`
            .length <= maxStreetAddressNumberLength);
    }
    return true;
}
//# sourceMappingURL=addressValidator.js.map